import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { ConfigService } from '../config/config.service';
import { SearchResult } from './search-result';

@Injectable()
export class SearchService {
    public visible = false;
    private api_url;

    constructor(private http: Http, private config: ConfigService) {
        this.api_url = this.config.get('api_url') + '/search/';
    }

    search(term: string): Observable<SearchResult> {
        const json = {
            'results': {
                'count': 3,
                'segments': {
                    'pages': [
                        {
                            'title': 'Test',
                            'description': 'This is the test page',
                            'score': 100,
                            'link': 'chassis.dev/pages/test',
                            'image': ''
                        }
                    ],
                    'users': [
                        {
                            'name': 'Tessa Goemans',
                            'score': 100,
                            'link': 'chassis.dev/users/1/Tessa',
                            'image': 'chassis.dev/images/users/1/avatar.png'
                        },
                        {
                            'name': 'Tessa Assen',
                            'score': 100,
                            'link': 'chassis.dev/users/17/Tessa',
                            'image': 'chassis.dev/images/users/17/avatar.png'
                        }
                    ]
                }
            },
            'suggestions': [
                'Test',
                'Tessa'
            ]
        };

        return new Observable(observer => {
            observer.next(new SearchResult(json));
        });

        // return this.http
        //     .get(this.api_url)
        //     .map(response => response.json().data as SearchResult);

        // return json as SearchResult;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/search/search.service.ts